import {
  HOVER_THIS, UNHOVER_THIS, hoverThis, unhoverThis,
} from '../actions/option_hover';

export function optionHoverReducer(state = {
  id: -102,
  parent: -102,
}, action) {
  switch (action.type) {
    case HOVER_THIS:
      return { ...state, id: action.id, parent: action.parent };
    case UNHOVER_THIS:
      return {
        id: -102,
        parent: -102,
      };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/option_hover.js